import React from 'react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme-react/text-area';
import 'devextreme-react/text-box';
import DataGrid, {
  FilterPanel,
  FilterRow,
  SearchPanel,
  Button,
  Paging,
  Lookup,
  Popup,
  //   Position,
  Editing,
  Export,
  Pager,
  Grouping,
  GroupPanel,
  RowDragging,
  Column,
  RequiredRule,
  Form
  //   PatternRule,
  //   EmailRule,
  //   AsyncRule,
} from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { Item } from 'devextreme-react/form';
import { useSelector } from 'react-redux';
import { Segment, Message, Icon, Header } from 'semantic-ui-react';
import { IStateProps } from '../../../types/auth';

import 'whatwg-fetch';

//********************FUNCTIONS******************************* */
function handleErrors(response: any) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}
// ********************FUNCTIONS******************************* */

const RepairNameGrid = () => {
  const [dataSource, setDataSource] = React.useState({});
  // const [rowData, setRowData]: any = React.useState({});
  const jwt = useSelector((state: IStateProps) => state.user.token);
  const baseAPI = useSelector((state: IStateProps) => state.config.baseURL);

  // console.log("1. baseapi", baseAPI);
  // console.log("1. jwt", jwt);

  React.useEffect(() => {
    const customDataSource: any = new CustomStore({
      key: 'repairNameOID',
      load: () => {
        return fetch(`${baseAPI}/CAMSRepairNames`, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })
          .then(handleErrors)
          .then((response) => response.json())
          .then((response) => {
            return {
              data: response.result.data,
              totalCount: response.count,
              summary: response.summary,
              groupCount: response.count
            };
          });
      },
      insert: (values) => {
        console.log('Value =' + JSON.stringify(values));
        return fetch(`${baseAPI}/CAMSRepairNames`, {
          method: 'POST',
          body: JSON.stringify(values),
          headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
          }
        }).then(handleErrors);
      },
      remove: (key) => {
        return fetch(`${baseAPI}/CAMSRepairNames/${key}`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        }).then(handleErrors);
      },
      update: (values) => {
        return values;
      }
    });

    //Save to store
    setDataSource(customDataSource);
  }, [baseAPI, jwt]);

  const onRowUpdating = (e: any) => {
    // console.log(Object.assign(e.oldData, e.newData));
    e.newData = Object.assign(e.oldData, e.newData);
    fetch(`${baseAPI}/CAMSRepairNames/${e.newData.repairNameOID}`, {
      method: 'PUT',
      body: JSON.stringify(e.newData),
      headers: {
        Authorization: `Bearer ${jwt}`,
        'Content-Type': 'application/json'
      }
    });
  };

  return (
    <Segment>
      <div>
        <Header as="h2">Repair Name </Header>
        <Message color="brown">
          <Message.Content>
            <Message.Header> Manage Repair Name</Message.Header>
            Create and manage Repair Name.
          </Message.Content>
        </Message>
      </div>
      <div>
        <DataGrid
          id="grdCamsRepairName"
          dataSource={dataSource && dataSource}
          // className="dx-datagrid dx-row-alt"
          hoverStateEnabled={true}
          columnAutoWidth={true}
          activeStateEnabled={true}
          columnResizingMode="widget"
          allowColumnResizing={true}
          onRowUpdating={onRowUpdating}
          //   onRowUpdating={(e: any) => console.log(e)}
          columnHidingEnabled={true}
          // onToolbarPreparing={handleToolPreparing}
        >
          <RowDragging allowReordering={true} />
          <FilterPanel visible={true} />
          <SearchPanel visible={true} />
          <FilterRow visible={true} />
          <Paging defaultPageSize={10} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50, 100]} showInfo={true} />
          <Grouping contextMenuEnabled={true} />
          <GroupPanel visible={true} />
          <Editing mode="popup" useIcons={true} allowUpdating={true} allowDeleting={true} allowAdding={true}>
            <Popup title="Repair Name" showTitle={true} width={700} height={550}></Popup>
            <Export enabled={true} fileName="Warehouses" allowExportSelectedData={true} />
            <Form>
              <Item itemType="group" colCount={2} colSpan={2}>
                <Item dataField="repairNameOID" />
                <Item dataField="repairCode" />
                <Item dataField="repairName" />
                {/* <Item dataField="secondaryMeter" /> */}
                {/* <Item dataField="allowNA" /> */}
                {/* <Item dataField="category" /> */}
                {/* <Item dataField="camsInspectionTemplateTasksVirtual" /> */}
                {/* <Item dataField="street" />
                <Item dataField="city" />
                <Item dataField="state" />
                <Item dataField="country" />
                <Item dataField="postCode" />
                <Item dataField="camsWarehouseList" /> */}
              </Item>
            </Form>
          </Editing>

          <Column type="buttons">
            <Button name="edit" icon="edit" />
            <Button name="delete" />
          </Column>
          <Column
            dataField="repairNameOID"
            allowEditing={false}
            // visible={false}
            width={120}
          ></Column>
          <Column dataField="repairName">
            <RequiredRule />
          </Column>
          <Column dataField="repairCode">
            <RequiredRule />
          </Column>
          {/* <Column dataField="secondaryMeter">
            <RequiredRule />
          </Column> */}

          {/* <Column dataField="allowNA"> <RequiredRule /> </Column> */}
          {/* <Column dataField="category">
            <RequiredRule />
          </Column> */}
          {/* <Column dataField="camsInspectionTemplateTasksVirtual">
            <RequiredRule />
          </Column> */}
          {/* <Column dataField="street">
            <RequiredRule />
          </Column>
          <Column dataField="city"></Column>
          <Column dataField="state">
            <RequiredRule />
          </Column>
          <Column dataField="country"></Column>
          <Column dataField="postCode"></Column>
          <Column dataField="camsWarehouseList"></Column> */}
        </DataGrid>
      </div>
    </Segment>
  );
};

export default RepairNameGrid;
